import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { StyledVehicleItem } from "./styles";
import { linkImage } from "@utils";
import { selectVehicleName } from "@redux";
interface IProps {
  item?: any;
  categoryId?: any;
}
export const VehicleItemComponent = (props: IProps) => {
  // props
  const { item } = props;
  //hooks
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const categoryId = query.get("categoryId");
  const subCategoryId = query.get("subCategoryId");
  const keyword = query.get("keyword");
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <StyledVehicleItem>
      <div
        className="wrapper disabled"
        onClick={() => {
          dispatch(selectVehicleName(item.title));
          // Build query by preserving existing values (keywordなど) and ensuring category/subCategory are passed
          const params = new URLSearchParams();
          if (categoryId) params.set("categoryId", String(categoryId));
          if (subCategoryId) params.set("subCategoryId", String(subCategoryId));
          if (keyword) params.set("keyword", String(keyword));
          const qs = params.toString();
          history.push(`/vehicles/calendar/${item?.id}${qs ? `?${qs}` : ""}`);
        }}
      >
        <div style={{ display: "flex" }}>
          <div className="wrapperImage">
            <img className="image" src={linkImage(item.image?.path)} alt="inventory item" loading="lazy" />
          </div>
          <div className="wrapperContent">
            <p className="title" >
              {item?.name}
            </p>
          </div>
        </div>
        {/* <span>{!item?.borrowing && <img src={star_icon} />}</span> */}
        <span>
          {!item?.borrowing && (
            <p style={{ color: "red" }}>{item?.isLate ? "遅延" : "使用中"}</p>
          )}
        </span>
      </div>
    </StyledVehicleItem>
  );
};
